export default __webpack_public_path__ + "static/media/miners-bg.8b6745a9.png";